import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../../shared/proxies/proxyGlobalAuth'
import { DeterminedBackgroundGraphic, DeterminedSignatureLogo } from '../../../../shared/themes/logoFunctions'

function LeftPanel (): ReactElement {
  const { siteDomainEnum, siteTheme } = useSnapshot(proxyGlobalAuth)
  return (
    <div
      className="relative w-0 md:w-1/2 h-screen"
      style={{ backgroundColor: siteTheme.loginBackground }}
    >
      <div className="absolute inset-0 h-screen w-full z-0">
        <DeterminedBackgroundGraphic theme={siteDomainEnum} />
      </div>

      <div className="absolute inset-x-1/2 inset-y-1/2 flex flex-col justify-center items-center z-10 pt-10">
        <div className="w-72 mb-8">
          <DeterminedSignatureLogo theme={siteDomainEnum} />
        </div>
        <div className="text-xl text-white w-64">Payment Solutions That</div>
        <div className="text-xl text-white w-64">Drive the Waste Industry</div>
      </div>
    </div>
  )
}
export default LeftPanel
